// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2b1fl","title":"ClientInsurance_title__3MQ7C","itemText":"ClientInsurance_itemText__2IJ-s"};